import { createRoutine } from 'redux-saga-routines';

export const fetchReferenceSurveyRoutine = createRoutine('FETCH_REF_SURVEY');

export const setRefContactInfoRoutine = createRoutine('SET_REF_CONTACT_INFO');
export const confirmReferenceRoutine = createRoutine('UPDATE_REF_DATA');

export const fetchQuestionsRoutine = createRoutine('FETCH_REF_QUESTIONS');
export const answerQuestionRoutine = createRoutine('ANSWER_QUESTION');

export const startSurveyRoutine = createRoutine('START_SURVEY');
export const finishSurveyRoutine = createRoutine('FINISH_SURVEY');
export const declineSurveyRoutine = createRoutine('DECLINE_SURVEY');

export const setPreviewDataRoutine = createRoutine('SET_PREVIEW_DATA');
export const setPreviewAnswerRoutine = createRoutine('SET_PREVIEW_ANSWER_ROUTINE');

export const createProspectRoutine = createRoutine('CREATE_PROSPECT');

export const checkSurveyKeyRoutine = createRoutine('CHECK_KEY_SURVEY');
export const checkSurveyCodeRoutine = createRoutine('CHECK_SURVEY_CODE');
